export default "__VITE_ASSET__D1Ab3SKj__"